import { useEffect, useRef } from 'react';
import { prefersReducedMotion } from './tokens';

// Adds `.is-in` to every `.reveal` descendant as it enters the viewport —
// the cheap path for the many elements that don't need scrubbed choreography.
export default function useReveal(options = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    const targets = root.querySelectorAll('.reveal');
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-in'));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Not in view and already above the viewport (fast scroll, deep
          // link, bfcache restore): show it now instead of never.
          const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (!entry.isIntersecting && !passed) return;
          const el = entry.target;
          const delay = Number(el.dataset.delay || 0);
          window.setTimeout(() => el.classList.add('is-in'), delay);
          io.unobserve(el);
        });
      },
      { rootMargin: options.rootMargin || '0px 0px -12% 0px', threshold: 0.1 }
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [options.rootMargin]);
  return ref;
}
